import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IDSEntry } from "../models/dsException";
import { throwApiError } from "./apiError";

/**
 * CRETE API call using Axios
 * @returns - Update delivered Short Entry and return same object
 */

export const UpdateDSEntryAPI = async (params: IDSEntry, osdNumber?: number | string) => {
  try {
    const response = await axios.put(`${getUrl(ApiType.DS_ENTRY_UPDATE)}/${osdNumber}`, params);
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.updateDSEntry, { badRequestOrder: "errorsFirst" });
  }
};
